import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonPrimaryComponent } from 'projects/components/button-primary/button-primary.component';
import { ErrorBadgeComponent } from 'projects/components/error-badge/error-badge.component';
import { InputComponent } from 'projects/components/input/input.component';
import { AccountService } from 'projects/login/src/app/services/auth/account.service';
import { PayErrorResponse } from 'projects/login/src/app/services/auth/models/pay-error-response';
import { TokenService } from 'projects/login/src/app/services/auth/token.service';

@Component({
  selector: 'pay-login-reset-password',
  imports: [ButtonPrimaryComponent, TranslateModule, InputComponent, ReactiveFormsModule, ErrorBadgeComponent],
  templateUrl: './reset-password.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetPasswordComponent implements OnInit {
  private readonly _router = inject(Router);
  private readonly _cdRef = inject(ChangeDetectorRef);
  private readonly _accService = inject(AccountService);
  private readonly _tokenService = inject(TokenService);

  isSubmitting = false;
  form = new FormGroup({
    email: new FormControl<string>('', [Validators.required, Validators.email]),
  });
  error?: PayErrorResponse;

  ngOnInit() {
    this._tokenService.accessToken = undefined;
    localStorage.setItem('sessionId', TokenService.sessionId!);
  }

  submit() {
    if (this.form.invalid) {
      return;
    }
    this.isSubmitting = true;
    this._cdRef.markForCheck();
    this._accService.passwordRecover({ email: this.form.controls.email.value! }).subscribe({
      next: () => {
        this._router
          .navigate(['/reset-requested'], {
            state: { email: this.form.controls.email.value },
          })
          .then();
      },
      error: (err) => {
        this.error = err.error as PayErrorResponse;
        this.isSubmitting = false;
        this._cdRef.detectChanges();
      },
    });
  }

  returnToLogin() {
    this._router.navigate(['/']);
  }
}
